import AboutHeader from './AboutHeader';

export default AboutHeader;
export * as AboutHeaderStyles from './AboutHeader.styles';
